module.exports = __webpack_public_path__ + "img/UTDEER-3.214f7c10.jpg";